import * as React from 'react';
import { FC } from 'react';

import { LoyaltyRewardsViewBase } from './loyalty-rewards.view.base';
import { ILoyaltyRewardsViewProps } from './types';

export const LoyaltyRewardsView: FC<React.PropsWithChildren<ILoyaltyRewardsViewProps>> = props => {
  return <LoyaltyRewardsViewBase {...props} />;
};
